export enum VisualsDashboardWidgetEnum {
    PhotoQuantityScore = 'PhotoQuantityScore',
    PhotoSizeScore = 'PhotoSizeScore',
    PhotoCategorizationScore = 'PhotoCategorizationScore',
    PhotoRoomTypeScore = 'PhotoRoomTypeScore',
    ReportsDownload = 'ReportsDownload',
    PropertyContentScore = 'PropertyContentScore',
    ContentScoreSummary = 'ContentScoreSummary',
    ListingsPendingActivationStatus = 'ListingsPendingActivationStatus',
    ListingsBeingEditedStatus = 'ListingsBeingEditedStatus',
    UncategorizedPhotos = 'UncategorizedPhotos',
    ListingsPublicationStatus = 'ListingsPublicationStatus',
    ImageTrackerPhotos = 'ImageTrackerPhotos',
    ImageTrackerDistribution = 'ImageTrackerDistribution',
    ImageTrackerListings = 'ImageTrackerListings',
    SizeScoreByListings = 'SizeScoreByListings',
    UnusedRoomTypes = 'UnusedRoomTypes',
    PublishedListingsHistory = 'PublishedListingsHistory',
    EnabledPhotosHistory = 'EnabledPhotosHistory',
    QualityScoreHistory = 'QualityScoreHistory',
    UnpublishedListings = 'UnpublishedListings',
    NeverPublishedListings = 'NeverPublishedListings',
    PhotoAge = 'PhotoAge',
    AverageAgeByListings = 'AverageAgeByListings',
    PhotoMeetingRoomScores = 'PhotoMeetingRoomScores',
    ScheduledReports = 'ScheduledReports',
}
